import {User} from 'constants/UserConstants';

export enum UserAdminActionType {
  USER_ADMIN_STATE_INITIALIZED = 'USER_ADMIN_STATE_INITIALIZED',
  USER_ADMIN_STATE_UPDATED = 'USER_ADMIN_STATE_UPDATED',
}

interface UserAdminStateInitializedAction {
  type: UserAdminActionType.USER_ADMIN_STATE_INITIALIZED;
  organizationId: string | null;
  usersById: {[userId: string]: User};
}
/**
 * Initialize store with bootstrapped data from Flask.
 */
export function adminStateInitialized({
  organizationId,
  usersById,
}: {
  organizationId: string | null;
  usersById: {[userId: string]: User};
}): UserAdminStateInitializedAction {
  return {
    type: UserAdminActionType.USER_ADMIN_STATE_INITIALIZED,
    organizationId,
    usersById,
  };
}

interface UserAdminStateUpdatedAction {
  type: UserAdminActionType.USER_ADMIN_STATE_UPDATED;
  updatedUsersById: {[userId: string]: User};
}

/**
 * @param updatedUsersById subset of users for whom new information is present (updates state with subset)
 */
export function userAdminStateUpdated(updatedUsersById: {
  [userId: string]: User;
}): UserAdminStateUpdatedAction {
  return {
    type: UserAdminActionType.USER_ADMIN_STATE_UPDATED,
    updatedUsersById,
  };
}

export type UserAdminAction = UserAdminStateInitializedAction | UserAdminStateUpdatedAction;
